import PropTypes from 'prop-types'
import { statusIndicationMemberOptions } from '../constants'
import {
  StatusIndicatorContainer,
  StatusIndicatorActive,
  StatusIndicatorInactive,
  StatusIndicatorInvited,
  StatusIndicatorUnlicensed
} from '../styled-components'
import { iconSizeOptions } from '../../icons/icons-sizes'

const membersStatusVariants = {
  [statusIndicationMemberOptions.INVITED]: StatusIndicatorInvited,
  [statusIndicationMemberOptions.ACTIVE]: StatusIndicatorActive,
  [statusIndicationMemberOptions.UNLICENSED]: StatusIndicatorUnlicensed,
  [statusIndicationMemberOptions.INACTIVE]: StatusIndicatorInactive
}

const StatusIndicationStatus = ({ size, status }) => {
  const Component = membersStatusVariants[status]

  return (
    <>
      {status !== statusIndicationMemberOptions.NO_STATUS && (
        <StatusIndicatorContainer size={size}>
          <Component className="status-indicator" />
        </StatusIndicatorContainer>
      )}
    </>
  )
}

StatusIndicationStatus.propTypes = {
  status: PropTypes.oneOf(Object.values(statusIndicationMemberOptions)),
  size: PropTypes.oneOf(Object.values(iconSizeOptions))
}

export default StatusIndicationStatus
